import { NotificationService } from '../../services/notification.service';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Store } from '../../store';
import { AuthService } from '../../services/auth.service';
import { AlertService } from '../../services/alert.service';
import { Router } from '@angular/router';
import { OverlayService } from '../../services/overlay.service';

@Component({
    selector: 'app-header-mobile',
    templateUrl: './header-mobile.component.html',
    styleUrls: ['./header-mobile.component.scss']
})
export class HeaderMobileComponent implements OnInit, AfterViewInit {
    @ViewChild('headerMobile') headerMobile: ElementRef;
    user$ = this.store.select<any>('user');
    basket$ = this.store.select<any>('basket');
    notifications$ = this.store.select<any>('notifications');
    chatStore$ = this.store.select<any>('chatStore');
    settings$ = this.store.select<any>('settings');
    deviceType$ = this.store.select<string>('deviceType');
    favourites$ = this.store.select<string>('favourites');
    publicTelNo$ = this.store.select<string>('publicTelNo');

    headerOverflow: boolean;
    showPromoBar = false;

    confirmationData = {
        open: false,
        title: '',
        detail: '',
        data: undefined
    };

    prevScrollpos;

    @HostListener('window:scroll', ['$event'])
    onWindowScroll(): void {
        /*        const currentScrollPos = window.pageYOffset;
                if (this.prevScrollpos > currentScrollPos) {
                    this.renderer.setStyle(this.headerMobile.nativeElement, 'top', '0');
                } else {
                    this.renderer.setStyle(this.headerMobile.nativeElement, 'top', '-80px');
                }
                this.prevScrollpos = currentScrollPos;*/
    }

    constructor(
        private store: Store,
        private authService: AuthService,
        private alertService: AlertService,
        public router: Router,
        private overlayService: OverlayService,
        private notificationService: NotificationService,
        private renderer: Renderer2
    ) {
    }

    ngOnInit(): void {
        const currentUrl = this.router.url;
        this.showPromoBar = currentUrl === '/';
    }

    ngAfterViewInit() {
        this.prevScrollpos = window.pageYOffset;
    }

    toggleMenu() {
        this.store.set('mobileMenu', true);
    }

    toggleMenuUser() {
        this.store.set('mobileMenuUser', true);
    }

    toggleNotifications() {
        this.overlayService.toggle('notifications');
    }

    toggleChat() {
        this.overlayService.toggle('chat');
    }

    register() {
        this.store.set('RegisteredInBasketFlow', false);
        // this.router.navigate(['/register']);
        this.overlayService.toggle('registerModal');
    }

    login() {
        this.overlayService.toggle('loginModal');
    }

    logout() {
        const notifications = { unread: 0, data: [] };
        const chatStore = {
            unread: 0,
            groups: [],
            group: undefined,
            replyingTo: undefined,
            groupToOpen: undefined,
            messages: [],
        };

        this.store.set('chatStore', chatStore);
        this.store.set('notifications', notifications);

        this.notificationService.stopListening();
        this.authService.logout().subscribe(() => {
            this.authService.clearAuthTimeout();
            this.router.navigate(['login']);
        });
    }

    logoutConfirmation() {
        this.confirmationData.title = 'Are you sure you want to logout?';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;
    }

    confirmationComplete(e) {
        this.confirmationData.open = false;
        if (e.action) {
            this.logout();
        } else {
        }
    }

    closeSubMenu(menuItem) {
        menuItem.open = false;
        // this.activeMenuImage = '';
    }

}
